import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ReportsState, getCacheLoaded, loadCache } from '../store';
import { tap, filter, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ReportCacheGuard  {

    constructor(
        private store: Store<ReportsState>
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const cacheKey: string = next.params.cacheKey;
        // TODO: Find out why this is now needed after angular major update and ngrx.
        let reloaded: boolean = false;

        return this.store.pipe(
            select(getCacheLoaded),
            tap(loaded => {
                if (!loaded && !reloaded) {
                    this.store.dispatch(loadCache({ cacheKey }));
                    reloaded = true;
                }
            }),
            filter(loaded => loaded),
            take(1)
        );
    }

}
